// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.yusetoken",
    name: "Yuse Wallet",
    homepage: "https://yusetoken.io/",
    image_id: "2cd61458-59c2-4208-c8ee-98b5e0076b00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/yuse-wallet/id6449364813",
        android: "https://play.google.com/store/apps/details?id=com.yuse.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "yuse://wallet://",
        universal: "https://yusewallet.page.link/tobR",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map